import { appURLs } from "@/app/app-urls.mjs";

function getElementIcon(element, ui = false) {
  return `${appURLs.CDN_PLAIN}/palworld/img/Elements/${element}${
    ui ? "_s" : ""
  }.webp`;
}

export const ELEMENTS = {
  Normal: {
    label: ["palworld:element.normal", "Neutral"],
    color: "#FFEFE7",
    imageSrc: getElementIcon("Normal"),
    iconSrc: getElementIcon("Normal", true),
  },
  Fire: {
    label: ["palworld:element.fire", "Fire"],
    color: "#FF724A",
    imageSrc: getElementIcon("Fire"),
    iconSrc: getElementIcon("Fire", true),
  },
  Electricity: {
    label: ["palworld:element.electric", "Electric"],
    color: "#FFDB2E",
    imageSrc: getElementIcon("Electricity"),
    iconSrc: getElementIcon("Electricity", true),
  },
  Earth: {
    label: ["palworld:element.ground", "Ground"],
    color: "#E4AA78",
    imageSrc: getElementIcon("Earth"),
    iconSrc: getElementIcon("Earth", true),
  },
  Water: {
    label: ["palworld:element.water", "Water"],
    color: "#52C9FF",
    imageSrc: getElementIcon("Water"),
    iconSrc: getElementIcon("Water", true),
  },
  Dark: {
    label: ["palworld:element.dark", "Dark"],
    color: "#BE1787",
    imageSrc: getElementIcon("Dark"),
    iconSrc: getElementIcon("Dark", true),
  },
  Ice: {
    label: ["palworld:element.ice", "Ice"],
    color: "#52C9FF",
    imageSrc: getElementIcon("Ice"),
    iconSrc: getElementIcon("Ice", true),
  },
  Leaf: {
    label: ["palworld:element.grass", "Grass"],
    color: "#BBFF52",
    imageSrc: getElementIcon("Leaf"),
    iconSrc: getElementIcon("Leaf", true),
  },
  Dragon: {
    label: ["palworld:element.dragon", "Dragon"],
    color: "#D978FF",
    imageSrc: getElementIcon("Dragon"),
    iconSrc: getElementIcon("Dragon", true),
  },
} as const;

export type ElementKind = keyof typeof ELEMENTS;
